import { GridCellValue } from "@material-ui/data-grid";

const currencyRow = (value: number) => `$${value}`;
const percentageRow = (value: number) => `${value}%`;
const flatRow = (value: number) => value;

export type RowType = "CURRENCY" | "PERCENTAGE" | "FLAT";

export const transformRowValue = (
  value: number | string | undefined | null,
  isNotApplicable: boolean,
  isFloat: boolean,
  type: RowType,
) => {
  const num = value === "" || value == null ? Number.NaN : Number(value);
  if (!Number.isFinite(num)) {
    return isNotApplicable ? "N/A" : type === "CURRENCY" ? "$0.00" : type === "PERCENTAGE" ? "0.00%" : 0;
  }

  const roundedValue = isFloat ? Number(num.toFixed(2)) : num;
  const validateValue = (v: number) => (isFloat ? Number.isFinite(v) : Number.isInteger(v));
  const emptyValue = isNotApplicable ? "N/A" : 0;
  const transformedValue =
    type === "CURRENCY"
      ? currencyRow(roundedValue)
      : type === "PERCENTAGE"
      ? percentageRow(roundedValue)
      : flatRow(roundedValue);

  return validateValue(roundedValue) ? transformedValue : emptyValue;
};

const toSortable = (v: GridCellValue) => {
  if (v == null) return { isNA: true, n: 0 };
  if (typeof v === "number") return { isNA: !Number.isFinite(v), n: Number.isFinite(v) ? v : 0 };

  const s = String(v).trim();
  if (s === "" || s === "N/A") return { isNA: true, n: 0 };

  const normalized = s.replace(/[\s$%,]/g, "").replace(/,/g, "");
  const n = Number.parseFloat(normalized);
  return { isNA: !Number.isFinite(n), n: Number.isFinite(n) ? n : 0 };
};

const naLastNumberComparator = (v1: GridCellValue, v2: GridCellValue) => {
  const a = toSortable(v1);
  const b = toSortable(v2);

  if (a.isNA && b.isNA) return 0;
  if (a.isNA && !b.isNA) return 1;
  if (!a.isNA && b.isNA) return -1;

  return a.n - b.n;
};

export const currencySortComparator = (v1: GridCellValue, v2: GridCellValue) => {
  return naLastNumberComparator(v1, v2);
};

export const percentageSortComparator = (v1: GridCellValue, v2: GridCellValue) => {
  return naLastNumberComparator(v1, v2);
};

export const flatSortComparator = (v1: GridCellValue, v2: GridCellValue) => {
  return naLastNumberComparator(v1, v2);
};
